import { ObserversModule } from '@angular/cdk/observers';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { SimplePanelComponent } from './simple-panel/simple-panel.component';
import { SimplePanelService } from './simple-panel/simple-panel.service';
import { SimpleMenuComponent } from './simple-panel/simple-menu.component';
import { LoadingOverlayComponent } from './loading-overlay.component';
import { SorterComponent } from './sorter/sorter.component';
import { NotificationsComponent, NotificationsService } from './notifications';
import { PreloaderComponent } from './preloader.component';
import { TableComponent } from './tables';


/**
 * Don't import directly use TccUiModule.forRoot() in your root module
 */
@NgModule({
  imports: [
    CommonModule,
    ObserversModule
  ],
  declarations: [
    // LabelForNextDirective,
    // HumanCasePipe,
    LoadingOverlayComponent,
    NotificationsComponent,
    PreloaderComponent,
    SimpleMenuComponent,
    SimplePanelComponent,
    SorterComponent,
    // CellTemplateRefDirective,
    TableComponent,
    // SorterHostDirective
  ],
  exports: [
    // LabelForNextDirective,
    // HumanCasePipe,
    LoadingOverlayComponent,
    NotificationsComponent,
    PreloaderComponent,
    SimpleMenuComponent,
    SimplePanelComponent,
    SorterComponent,
    // SorterHostDirective,
    // CellTemplateRefDirective,
    TableComponent,
    CommonModule
  ]
})
export class TccUiModule {
  static forRoot(): ModuleWithProviders<TccUiModule> {
    return {
      ngModule: TccUiModule,
      providers: [
        // FileDownloadService,
        // GenericCanDeactivateGuard,
        NotificationsService,
        // ScrollService,
        SimplePanelService,
        // TemplateUtilService,
        { provide: Window, useValue: window }
      ]
    };
  }
}
